// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"a7d37a0b","151":"4817bcbb","585":"121b1890","851":"1550f33b"}[chunkId] + ".chunk.js";
};